import { QueryBooleanSchema } from 'notable-common';
import { z } from 'zod';
/**
 * One branch of a notification conversation: the replies that select it, and the content to send
 * back when they do. `intent` is a free-text label, not an enum — primary recognises a handful of
 * standard ones (confirm, cancel) to drive appointment status, and treats the rest as opaque.
 */
export const NotificationIntentSchema = z.object({
    id: z.uuid(),
    created: z.iso.datetime(),
    updated: z.iso.datetime(),
    notificationContentId: z.uuid(),
    intent: z.string(),
    replies: z.array(z.string()),
    nextNotificationContentId: z.uuid().nullable(),
    deletedTimestamp: z.iso.datetime().nullable(),
});
export const NotificationIntentFindAllQuerySchema = z
    .object({
    // Not `z.uuid()`, though it is one: joi accepted any string, and rejecting a malformed id here
    // would turn today's empty result into a 400.
    contentId: z
        .string()
        .optional()
        .describe('Return only the intents defined on this notification content.'),
    includeDeleted: QueryBooleanSchema.optional().describe('Include intents that have been deleted.'),
})
    .strict();
//# sourceMappingURL=intent.js.map